import { isTablet } from 'react-native-device-info';
const useIsTablet = () => {
    return isTablet();
};
export default useIsTablet;
